export default __webpack_public_path__ + "static/media/Char5.98ef8f78.png";